import { images } from './images';
import type { OwnerDocument, OwnerVehicleType } from '../types/owner';

export const ownerImages = {
  motorcycle: 'https://cdn.magicpatterns.com/patterns/generated-images/8af0762b-29be-4974-9694-bcd77addc9a7.jpg',
  docScan: 'https://cdn.magicpatterns.com/patterns/generated-images/f23651a4-3c30-43a0-b758-c0e879f2f452.jpg'
};

export const ownerProfile = {
  id: 'OWN-2026-000125',
  name: 'মোঃ রহিম উদ্দিন',
  father: 'মোঃ আব্দুল করিম',
  mother: 'মোছাঃ রহিমা বেগম',
  nid: '১৯৮৭৬৫৪৩২১০৯৮',
  dob: '১৫/০৫/১৯৮৭',
  gender: 'পুরুষ',
  mobile: '০১৭১২৩৪৫৬৭৮',
  mobileMasked: '০১৭১২****৭৮',
  altMobile: '০১৯১৫৬৭৮৯০১',
  email: 'rahim.uddin@gmail.com',
  present: 'বাড়ি ২৮, রোড ৩, সেকশন ১০, মিরপুর, ঢাকা',
  permanent: 'গ্রাম: চরপাড়া, ডাকঘর: মধুপুর, টাঙ্গাইল',
  division: 'ঢাকা',
  district: 'ঢাকা',
  thana: 'মিরপুর মডেল থানা',
  post: '১২১৬',
  photo: images.owner
};

export interface OwnerVehicle {
  id: string;
  type: OwnerVehicleType;
  typeLabel: string;
  reg: string;
  brand: string;
  model: string;
  color: string;
  year: string;
  chassis: string;
  engine: string;
  fuel: string;
  regDate: string;
  ownership: string;
  qrId: string;
  image: string;
  appId: string;
  stickerIssued?: string;
  division: string;
}

export const ownerVehicles: OwnerVehicle[] = [
  {
    id: 'c1',
    type: 'cng',
    typeLabel: 'সিএনজি',
    reg: 'ঢাকা-থ-১১-১২৩৪',
    brand: 'বাজাজ',
    model: 'RE 4S',
    color: 'সবুজ',
    year: '২০২১',
    chassis: 'MDH12F45ABC123456',
    engine: 'ENG987654321',
    fuel: 'CNG',
    regDate: '১২/০১/২০২২',
    ownership: 'একক মালিকানা',
    qrId: 'DMP-CNG-000001',
    image: images.cng,
    appId: 'DMP-OWN-2026-000098',
    stickerIssued: '১০/১০/২০২৬',
    division: 'ট্রাফিক-মিরপুর'
  },
  {
    id: 'c15',
    type: 'motorcycle',
    typeLabel: 'মোটরসাইকেল',
    reg: 'ঢাকা মেট্রো-ল-৪৫-৬৭৮৯',
    brand: 'Yamaha',
    model: 'FZS V3',
    color: 'কালো',
    year: '২০২৩',
    chassis: 'ME1RG1234K0005678',
    engine: 'G3J3E0098765',
    fuel: 'পেট্রোল',
    regDate: '০৮/০৩/২০২৩',
    ownership: 'একক মালিকানা',
    qrId: 'DMP-MCL-000002',
    image: ownerImages.motorcycle,
    appId: 'DMP-OWN-2026-000117',
    division: 'ট্রাফিক-মিরপুর'
  }
];

export const ownerDocuments: Record<string, OwnerDocument[]> = {
  c1: [
    { key: 'reg', name: 'রেজিস্ট্রেশন সার্টিফিকেট', number: 'BRTA-RC-DH-2022-118734', issue: '১২/০১/২০২২', expiry: 'প্রযোজ্য নয়', daysLeft: null, authority: 'BRTA, মিরপুর সার্কেল' },
    { key: 'fitness', name: 'ফিটনেস সার্টিফিকেট', number: 'FIT-2025-DH-558821', issue: '০১/০৭/২০২৫', expiry: '৩০/০৬/২০২৭', daysLeft: 625, authority: 'BRTA, মিরপুর সার্কেল' },
    { key: 'tax', name: 'ট্যাক্স টোকেন', number: 'TAX-2026-0098341', issue: '০১/০১/২০২৬', expiry: '৩১/১২/২০২৬', daysLeft: 79, authority: 'BRTA' },
    { key: 'route', name: 'রুট পারমিট', number: 'RP-DMP-CNG-2025-04417', issue: '১৬/১১/২০২৫', expiry: '১৫/১১/২০২৬', daysLeft: 33, authority: 'মেট্রো RTC, ঢাকা' },
    { key: 'cylinder', name: 'সিলিন্ডার পরীক্ষার সনদ', number: 'CYL-RNG-58214', issue: '১৯/১০/২০২৩', expiry: '১৮/১০/২০২৬', daysLeft: 5, authority: 'বিস্ফোরক পরিদপ্তর' },
    { key: 'owner', name: 'মালিকানার প্রমাণপত্র', number: 'SALE-DEED-2021-7781', issue: '২৮/১২/২০২১', expiry: 'প্রযোজ্য নয়', daysLeft: null, authority: 'BRTA' },
    { key: 'photo', name: 'গাড়ির ছবি', number: '৪টি ছবি (সামনে, পেছনে, দুই পাশ)', issue: '২২/০৯/২০২৬', expiry: 'প্রযোজ্য নয়', daysLeft: null, authority: 'মালিক কর্তৃক আপলোড' }
  ],
  c15: [
    { key: 'reg', name: 'রেজিস্ট্রেশন সার্টিফিকেট', number: 'BRTA-RC-DM-2023-445678', issue: '০৮/০৩/২০২৩', expiry: 'প্রযোজ্য নয়', daysLeft: null, authority: 'BRTA, ইকুরিয়া' },
    { key: 'tax', name: 'ট্যাক্স টোকেন', number: 'TAX-2026-0211873', issue: '২১/০২/২০২৬', expiry: '২০/০২/২০২৭', daysLeft: 130, authority: 'BRTA' },
    { key: 'insurance', name: 'বীমা সনদ', number: 'INS-GRN-2025-118745', issue: '০৬/১০/২০২৫', expiry: '০৫/১০/২০২৬', daysLeft: -8, authority: 'গ্রিন ডেল্টা ইন্স্যুরেন্স' },
    { key: 'owner', name: 'মালিকানার প্রমাণপত্র', number: 'INV-YMH-2023-00981', issue: '০২/০৩/২০২৩', expiry: 'প্রযোজ্য নয়', daysLeft: null, authority: 'ACI মোটরস' },
    { key: 'photo', name: 'গাড়ির ছবি', number: '৩টি ছবি', issue: '০৮/১০/২০২৬', expiry: 'প্রযোজ্য নয়', daysLeft: null, authority: 'মালিক কর্তৃক আপলোড' }
  ]
};

export const roadsideHistory: Record<string, { date: string; time: string; division: string; result: 'বৈধ' | 'সতর্কতা'; comment: string }[]> = {
  c1: [
    { date: '১৩/১০/২০২৬', time: 'সকাল ০৮:৪৫', division: 'ট্রাফিক-মিরপুর', result: 'বৈধ', comment: 'চালক: মোঃ সেলিম উদ্দিন — সকল তথ্য বৈধ' },
    { date: '১২/১০/২০২৬', time: 'সকাল ১০:৩০', division: 'ট্রাফিক-মিরপুর', result: 'বৈধ', comment: 'চালক: মোঃ করিম শেখ — সকল তথ্য বৈধ' },
    { date: '১১/১০/২০২৬', time: 'বিকাল ০৪:১৫', division: 'ট্রাফিক-গুলশান', result: 'সতর্কতা', comment: 'চালকের লাইসেন্সের মূল কপি সাথে ছিল না — মৌখিক সতর্ক করা হয়েছে' },
    { date: '১১/১০/২০২৬', time: 'সকাল ০৯:১০', division: 'ট্রাফিক-তেজগাঁও', result: 'বৈধ', comment: 'চালক: মোঃ আক্তার হোসেন — সকল তথ্য বৈধ' }
  ],
  c15: []
};

export const trafficNotices = [
  { id: 'DMP-TRF-2026-121905', date: '০৮/১০/২০২৬', offence: 'ট্রাফিক সংকেত অমান্য (ধারা ৮৪)', place: 'ফার্মগেট মোড়', amount: '৳ ৫,০০০', status: 'অপরিশোধিত', vehicleId: 'c1' },
  { id: 'DMP-TRF-2026-118734', date: '২৮/০৯/২০২৬', offence: 'নির্ধারিত স্থানের বাইরে যাত্রী ওঠানামা', place: 'মিরপুর-১০ গোলচত্বর', amount: '৳ ১,০০০', status: 'নিষ্পত্তি — জরিমানা পরিশোধিত', vehicleId: 'c1' }
];

export const collectionPoint = {
  name: 'ডিএমপি ট্রাফিক বিভাগ (মিরপুর) — স্টিকার বিতরণ কেন্দ্র',
  address: 'মিরপুর-১০ গোলচত্বর সংলগ্ন, ট্রাফিক জোনাল অফিস, ঢাকা-১২১৬',
  hours: 'রবি–বৃহস্পতি, সকাল ১০:০০ – বিকাল ৪:০০',
  phone: '০১৩২০-০৪২১১০',
  bring: ['মালিকের মূল NID', 'রেজিস্ট্রেশন সার্টিফিকেট (মূল)', 'আবেদন আইডি / SMS']
};

export function docTone(days: number | null): { label: string; tone: 'green' | 'orange' | 'red' } {
  if (days === null || days > 60) return { label: 'বৈধ', tone: 'green' };
  if (days >= 0) return { label: 'শিগগির মেয়াদ শেষ', tone: 'orange' };
  return { label: 'মেয়াদোত্তীর্ণ', tone: 'red' };
}
